import { Component, HostListener, OnInit } from '@angular/core';
import { GetHomeChargerService } from '../get-home-charger/get-home-charger.service';
import { CommunicationService } from '../services/communication.service';
import { CPMixPanel } from '../services/mixpanel.service';
import { FrontendContentConfigService } from '../services/frontend-content-config.service';
import { UiFlowStateService } from '../services/ui-flow-state.service';
import { ConnectionService } from '../connection/connection.service';
import { DiscoveryStoreService } from '../services/discovery.service';

@Component({
  selector: 'cp-home-charger-done',
  templateUrl: './home-charger-done.component.html',
  styleUrls: ['./home-charger-done.component.scss']
})
export class HomeChargerDoneComponent implements OnInit {
  chargePointInstall = false;
  companyName = '';
  viewAccountUrl = '';
  // QR points at a static redirect page that sniffs the scanning device's OS:
  // iOS -> App Store, everything else (Android/other) -> Google Play.
  qrDownloadUrl = `${window.location.origin}/assets/app-download.html`;
  // EU shows the redesigned beta-onboarding page; every other region keeps the original page.
  isEu = false;
  calloutTextBold = "Already have a ChargePoint account & joining through a new connection?";
  calloutTextRest = "No need to download, just sign in on your current app - we'll connect your existing account to the new programme.";
  iosSteps = [
    'Download <a href="https://apps.apple.com/us/app/testflight/id899247664" target="_blank" rel="noopener">TestFlight</a> from the App Store on your iPhone.',
    'Tap <a href="https://testflight.apple.com/join/4HUvq88M" target="_blank" rel="noopener">this link</a> to accept your ChargePoint Open Beta invitation — it will open automatically in TestFlight.',
    'Tap <strong>Install</strong>, then <strong>Open</strong> to launch the ChargePoint Beta app.'
  ];
  androidSteps = [
    'Make sure your device is running <strong>Android 8</strong> or later.',
    'Tap <a href="https://play.google.com/store/apps/details?id=com.coulombtech" target="_blank" rel="noopener">this link</a> to open the ChargePoint Beta page on Google Play.',
    'Tap <strong>Install</strong>. Once it finishes, open the app to get started.'
  ];
  @HostListener('window:beforeunload', ['$event'])
  closePage($event: any) {
    this.uiFlowState.clearSessionStorage();
  }

  constructor(
    protected homeChargerSvc: GetHomeChargerService,
    protected comSvc: CommunicationService,
    protected mixPanel: CPMixPanel,
    protected frontendConfigSvc: FrontendContentConfigService,
    protected uiFlowState: UiFlowStateService,
    protected connectionService: ConnectionService,
    protected discoveryService: DiscoveryStoreService
  ) { }

  ngOnInit() {
    this.uiFlowState.setSignUpFinished();
    this.isEu = !!this.discoveryService.getDiscoveryData()?.endPoints?.accounts_endpoint?.value?.includes('eu');
    this.viewAccountUrl = this.comSvc.getViewAccountLink();
    this.homeChargerSvc.getHomeChargerStatus().subscribe(
      statusObj => {
        if (statusObj && statusObj.companyName) {
          this.companyName = statusObj.companyName;
        } else {
          // No company from the home-charger status (e.g. connections without a home charger) — fall back to the connection config.
          this.loadCompanyNameFromConnection();
        }
      },
      () => this.loadCompanyNameFromConnection()
    );
    this.chargePointInstall = this.comSvc.isInstallHomeCharger();
    this.frontendConfigSvc.setBodyTitle('successTitle');
  }

  private loadCompanyNameFromConnection() {
    const token = this.comSvc.getPartnerToken();
    if (!token) {
      return;
    }
    this.connectionService.getFields(token).subscribe((resp: any) => {
      if (resp && resp.orgName) {
        this.companyName = resp.orgName;
      }
    });
  }

  clickDownload(market: string) {
    if (market === 'apple') {
      this.mixPanel.successAppleApp();
    } else if (market === 'google') {
      this.mixPanel.successGoogleApp();
    }
  }
}
